// extracted by mini-css-extract-plugin
export default {"container":"filter-label_container__Ut-PH","text":"filter-label_text__a-q27"};